import { useCallback, useMemo } from 'react';
import type { MemberHeaderAction } from '@library/types/members';
import { useCreateMemberNoteMutation } from '@bo-services/members/memberNotesApi';
import { useParams } from 'react-router-dom';

export const useMemberNoteActions = () => {
  const { memberId } = useParams<{ memberId?: string }>();
  const [createMemberNote] = useCreateMemberNoteMutation();

  const handleSubmitCreateNote = useCallback(
    async (noteDescription?: string) => {
      if (!memberId || !noteDescription) {
        throw new Error('Member ID and Note Description are required');
      }

      await createMemberNote({ memberId, noteDescription });
    },
    [createMemberNote, memberId]
  );

  const createNoteActions: MemberHeaderAction = useMemo(
    () => ({
      onSubmit: handleSubmitCreateNote
    }),
    [handleSubmitCreateNote]
  );

  return {
    createNoteActions
  };
};
